import React from "react";
import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import SEO from "../../hooks/SEO";
import PageBanner from "../../components/PageBanner";
import PortfolioCompanyCard from "../../components/PortfolioCompanyCard";
import CapabilityCard from "../../components/CapabilityCard";
import SectionHeader from "../../components/SectionHeader";
import CTASection from "../../components/CTASection";
import {
  portfolioCompanies,
  seoContent,
  siteMeta,
  supportCapabilities,
} from "../../data/mockData";

const Portfolio = () => (
  <>
    <SEO
      title={seoContent.portfolio.title}
      description={seoContent.portfolio.description}
      name={siteMeta.name}
      type="website"
    />
    <PageBanner
      title="Portfolio Capabilities"
      description="Refwa's operating capacity extends across construction, equipment support, environmental services, facilities, water, and related project services."
      image={siteMeta.bannerImage}
      breadcrumbs={[{ label: "Portfolio" }]}
    />

    <Box className="site-section">
      <Container>
        <Paper
          sx={{
            p: { xs: 3, md: 3.8 },
            mb: { xs: 4.5, md: 5.5 },
            border: "1px solid var(--color-border)",
            boxShadow: "var(--shadow-card)",
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(252,248,242,0.96))",
          }}
        >
          <Grid container spacing={{ xs: 3, md: 4 }} sx={{ width: "100%", m: 0 }}>
            <Grid item xs={12} lg={7}>
              <Box className="eyebrow">Operating Capacity</Box>
              <Typography variant="h3" sx={{ mt: 1.6, maxWidth: 650 }}>
                Group Capabilities
              </Typography>
            </Grid>
            <Grid item xs={12} lg={5}>
              <Typography variant="body1" color="text.secondary">
                Refwa's wider operations include construction, environmental
                services, workforce support, water solutions, facilities, and
                related project services, while mining, petroleum services, and
                trade remain core business lines.
              </Typography>
            </Grid>
          </Grid>
        </Paper>

        <SectionHeader
          eyebrow="Supporting Entities"
          title="Portfolio Companies"
          description="These companies reflect operating capacity across construction, equipment, environmental services, facilities, and water-related work."
        />
        <Grid container spacing={3} sx={{ width: "100%", m: 0 }}>
          {portfolioCompanies.map((company) => (
            <Grid item xs={12} md={6} lg={4} key={company.id}>
              <PortfolioCompanyCard {...company} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>

    <Box className="site-section site-section--white">
      <Container>
        <SectionHeader
          eyebrow="Capability Areas"
          title="Service Areas"
          description="Refwa's wider operating scope covers infrastructure support, civil works, equipment services, environmental response, facility support, and water-related solutions."
        />
        <Grid container spacing={3} sx={{ width: "100%", m: 0 }}>
          {supportCapabilities.map((item) => (
            <Grid item xs={12} md={6} lg={4} key={item.title}>
              <CapabilityCard {...item} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>

    <CTASection
      title="Related Services"
      description="View Refwa's service lines for mining, petroleum services, international trade, and related project support."
      primaryLabel="Explore Services"
      primaryTo="/services"
      secondaryLabel="Contact Refwa"
      secondaryTo="/contact"
    />
  </>
);

export default Portfolio;
